<template>
  <div class="main" id="contentMain" ref="contentMain">
    <div class="main-left">
      <div class="main-title">
       <div>
         随笔
       </div>
        <div class="title-more" @click="moreClick">
          更多
        </div>
      </div>
      <div class="content" ref="essayArea" @scroll="handleScroll('essayArea')">
        <div class="cont cont-block">
          <template v-for="(essay,index) in currentEssayList">
            <essay-component :essay-obj="essay" :key="index" @click="essayClick(essay)"></essay-component>
          </template>
        </div>
        <div v-if="essayLoading">加载中……</div>
        <div v-else-if="essayFinished">已加载全部</div>
      </div>
    </div>
    <div class="main-right">
      <div class="main-title">
        <div>
          心情
        </div>
        <div class="title-more" @click="moreClick">
          更多
        </div>
      </div>
      <div class="content" ref="postArea" @scroll="handleScroll('postArea')">
        <div class="cont-block">
          <template v-for="(post,index) in postList">
            <post-component :post-obj="post" :key="index" @click="postDetailClick(post)" :hidden-flag="true"></post-component>
          </template>
        </div>
        <div v-if="postLoading">加载中……</div>
        <div v-else-if="postFinished">已加载全部</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getEssayGroupMap, getEssayList, getEssayListPage } from '@/api/essayApi'
import { getMenuList, getMenuTree } from '@/api/menuApi'
import { getPostList } from '@/api/postApi'
import EssayComponent from '@/page/essay/essayComponent'
import PostComponent from '@/page/post/postComponent'
import RssIndex from "@/page/rss";

export default {
  name: "h-main",
  components: {RssIndex, PostComponent, EssayComponent },
  data() {
    return {
      essayMap:{},
      menuList:[],
      postList:[],
      currentContentId:0,
      currentEssayList:[],
      essayQuery:{},
      postQuery:{},
      essayLoading: false,
      postLoading: false,
      essayFinished: false,
      postFinished: false,
    }
  },
  computed:{
    getContentMenuList(){
      return Object.keys(this.essayMap)
    },
    getContentEssayList() {
      return Object.values(this.essayMap).flat();
    },
  },
  mounted() {
    this.init();
  },
  destroyed() {
  },
  methods: {
    init(){
      this.queryReset();
      // this.getMenuList();
      this.getPostList();
      this.getEssayList();
    },
    /**
     * 项目点击事件
     * @param essay
     */
    postDetailClick(post){
      let params = {};
      params.postId = post.id;
      this.$router.push({ path: '/post', query: params});
    },
    /**
     * 项目点击事件
     * @param essay
     */
    essayClick(essay){
      let params = {};
      params.essayId = essay.id;
      this.$router.push({ path: '/essay', query: params});
    },
    /**
     * 获取内容菜单
     */
    getMenuList() {
      const $this = this
      getMenuList({ type: '2' }).then(res => {
        $this.menuList = res.rows
        $this.currentContentId = $this.menuList[0].id;
        // $this.getEssayList($this.menuList[0].id);
      })
    },
    /**
     * 获取post集合
     */
    getPostList(){
      const $this = this;
      $this.postLoading = true;
      let params = {};
      params.pageNum = $this.postQuery.pageNum;
      params.pageSize = $this.postQuery.pageSize;
      getPostList(params).then(res =>{
        $this.postList = [...$this.postList , ...res.rows];
        $this.postQuery.total = res.total;
      }).finally(()=>{
        $this.postLoading = false;
      })
    },
    /**
     * 获取essay数据集合
     */
    getEssayListPage(){
      const $this = this;
      $this.loading = true;
      let params = {};
      params.pageNum = $this.essayQuery.pageNum;
      params.pageSize = $this.essayQuery.pageSize;
      getEssayListPage(params).then(res =>{
        $this.currentEssayList = res.rows;
        $this.essayQuery.total = res.total;
      }).finally(()=>{
        $this.loading = false;
      })
    },
    /**
     * 获取essay数据集合
     */
    getEssayList(){
      const $this = this;
      $this.essayLoading = true;
      let params = {};
      params.pageNum = $this.essayQuery.pageNum;
      params.pageSize = $this.essayQuery.pageSize;
      getEssayListPage(params).then(res =>{
        $this.currentEssayList = [...$this.currentEssayList , ...res.rows];
        $this.essayQuery.total = res.total;
        this.essayLoading = false;
      })
    },
    /**
     * 菜单点击事件
     * @param menu
     */
    contentMenuClick(menu){
      //重新加载内容
      const $this = this;
      $this.currentContentId = menu.id;
      $this.queryReset();
      $this.getEssayList(menu.id);
    },

    /**
     * 查询参数重置
     */
    queryReset(){
      this.essayQuery = {
        pageNum: 1,
        pageSize: 5,
        total:null,
      }
      this.postQuery = {
        pageNum: 1,
        pageSize: 5,
        total:null,
      }
      this.currentEssayList = [];
    },
    /**
     * 页面滚动事件
     */
      handleScroll(type) {
      const container = this.$refs[type];
      if (container.scrollTop + container.clientHeight + 1 >= container.scrollHeight) {
        // 到达底部，加载下一页
        if(type == 'essayArea'){
          if (!this.essayLoading) {
            if(this.essayQuery.pageNum * this.essayQuery.pageSize >= this.essayQuery.total){
              this.essayFinished = true;
            }else {
              this.page++;
              this.essayQuery.pageNum += 1;
              this.getEssayList();
            }
          }
        }else if(type == 'postArea'){
          if (!this.postLoading) {
            if(this.postQuery.pageNum * this.postQuery.pageSize >= this.postQuery.total){
              this.postFinished = true;
            }else {
              this.page++;
              this.postQuery.pageNum += 1;
              this.getPostList();
            }
          }
        }

      }
    },
    moreClick(){
      this.$router.push({ path: '/search'});
    },

  }
}
</script>

<style scoped>
@import '../../static/css/h-main.css';

/* 滚动条优化 start */
::-webkit-scrollbar{
  width:6px;height:6px;
  background-color: #fff;
}

::-webkit-scrollbar-track{
  background-color:transparent;
}
::-webkit-scrollbar-thumb {
  background: #B6B6B6FF;
  border-radius: 2px;
}
::-webkit-scrollbar-thumb:hover {
  background: #747474;
}
::-webkit-scrollbar-corner {
  background: #f6f6f6;
}
/* 滚动条优化 end */
</style>
